import { useCallback } from 'react';
import { useShowPdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import { useStoreActions, useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export function usePreviewCustomPagePdf(param) {
    let { biName, testId } = param;
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const showPdfViewerModal = useShowPdfViewerModal();
    const { t: pdfUploadTexts } = useLocaleKeys('customPages.pdfUpload');
    const openPreview = useCallback((pdfName)=>{
        showPdfViewerModal({
            biName,
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            title: pdfUploadTexts.previewModalTitle(),
            pdfUniqueName: pdfName,
            getFileUrl: async (pdfUniqueName)=>{
                const result = await api.customPage.getDownloadUrl(businessId !== null && businessId !== void 0 ? businessId : '', pdfUniqueName);
                return result.url;
            },
            testId
        });
    }, [
        api.customPage,
        biName,
        businessId,
        showPdfViewerModal,
        testId
    ]);
    return {
        openPreview
    };
}
